<template>
    <div>
        <!--快捷注册第一步-->
        <Modal v-model="modalStatus" width="600px" :mask-closable="false">
            <div slot="close" class="close-btn">
                <Icon type="close-round" @click="handleClose" color="#5c6b77" size="15"></Icon>
            </div>
            <div class="login-header">企业注册</div>

            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
                <Row>
                    <Col span="24">
                    <FormItem label="企业名称" prop="name">
                        <Input v-model.trim="formValidate.name" placeholder="请输入企业名称" style="width: 100%"></Input>
                    </FormItem>
                    </Col>
                </Row>

                <Row>
                    <Col span="16">
                    <FormItem label="邮寄地址" prop="provinceId">
                        <Select v-model="formValidate.provinceId" placeholder="请选择省/直辖市" style="width: 70%">
                            <Option v-for="(item, index) in provinceList" :key="index" :value="item.id">{{ item.name }}</Option>
                        </Select>
                        <span>省/直辖市</span>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="" prop="cityId" :label-width="10">
                        <Select v-model="formValidate.cityId" placeholder="请选择城市" style="width: 90%">
                            <Option v-for="(item, index) in cityList" :key="index" :value="item.id">{{ item.name }}</Option>
                        </Select>
                        <span>市</span>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                    <FormItem prop="address">
                        <Input v-model.trim="formValidate.address" placeholder="请输入详细地址" style="width: 100%"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                    <FormItem label="联系人" prop="contactName">
                        <Input v-model.trim="formValidate.contactName" placeholder="请输入联系人" style="width: 100%"></Input>
                    </FormItem>
                    </Col>
                </Row>

                <Row>
                    <Col span="24">
                    <FormItem label="手机号码" prop="contactPhone">
                        <Input v-model.trim="formValidate.contactPhone" placeholder="请输入手机号码" style="width: 100%"></Input>
                    </FormItem>
                    </Col>
                </Row>

                <div style="display: flex; align-items: flex-start">
                    <div style="flex: 1">
                        <FormItem label="短信验证码" prop="smsCode">
                            <Input v-model.trim="formValidate.smsCode" placeholder="请输入短信验证码">
                            </Input>
                        </FormItem>
                    </div>

                    <Button type="primary" style="margin-left: 3%" :loading="sendCodeBtnDisabled" @click="handleVerifyCodeBtn">
                        <span v-if="!sendCodeBtnDisabled">获取验证码</span>
                        <span v-else>{{ sendCodeTimeCount }}秒</span>
                    </Button>
                </div>
            </Form>

            <div slot="footer">
                <Button type="primary" :loading="loading" long @click="handleReg">注册</Button>
            </div>
        </Modal>
        <!--滑动验证-->
        <verfy ref="verfy" @success="verifySuccess"></verfy>
    </div>
</template>
<script>
import { postEntSysUser } from "../api/ent";
import { postUploadPhoto, getQueryChina } from "../api/common";
import { postSendSms } from "../api/user.js";
import verfy from "../components/Verify.vue";
import mtils from "mtils";
export default {
    components: {
        verfy,
    },
    data() {
        //校验手机号码
        const validateMobile = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号码不能为空"));
            }
            if (!mtils.validation.isMobile(value)) {
                return callback(new Error("手机号码格式不正确"));
            }
            callback();
        };
        return {
            loading: false,

            //注册信息
            formValidate: {
                contactName: "",
                name: "",
                contactPhone: "",
                address: "",
                provinceId: "",
                provinceName: "",
                cityId: "",
                cityName: "",
                smsCode: "",
            },

            provinceList: [],
            cityList: [],

            sendCodeBtnDisabled: false,
            sendCodeTimeCount: 0,
            sendCodeTimer: null,

            //注册校验
            ruleValidate: {
                contactName: [
                    {
                        required: true,
                        message: "联系人不可为空",
                        trigger: "blur",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "企业名称不可为空",
                        trigger: "blur",
                    },
                ],
                contactPhone: [
                    {
                        required: true,
                        message: "手机号码不可为空",
                        trigger: "blur",
                    },
                    {
                        validator: validateMobile,
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "详细地址不可为空",
                        trigger: "blur",
                    },
                ],

                provinceId: [
                    {
                        type: "number",
                        required: true,
                        message: "所属省不可为空",
                        trigger: "change",
                    },
                ],

                cityId: [
                    {
                        type: "number",
                        required: true,
                        message: "所属市不可为空",
                        trigger: "change",
                    },
                ],

                smsCode: [
                    {
                        required: true,
                        message: "验证码不可为空",
                        trigger: "blur",
                    },
                ],
            },
            //模态框
            modalStatus: false,
        };
    },
    watch: {
        "formValidate.provinceId"(val) {
            if (val) {
                this.formValidate.cityId = "";
                this.formValidate.cityName = "";
                this.formValidate.address = "";
                this.getQueryCity(val);
            }
        },

        "formValidate.cityId"(val) {
            if (val) {
                this.formValidate.address = "";
            }
        },

        modalStatus(val) {
            if (!val) {
                clearInterval(this.sendCodeTimer);
                this.sendCodeBtnDisabled = false;
                this.sendCodeTimeCount = 0;
                this.$refs["formValidate"].resetFields();
            }
        },
    },
    created() {
        // this.getQueryProvince();
    },
    methods: {
        async handleVerifyCodeBtn(rule, value, callback) {
            let patternAccount =
                /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
            if (!this.formValidate.contactPhone) {
                this.$Message.info("手机号码不可为空!");
            } else if (!patternAccount.test(this.formValidate.contactPhone)) {
                this.$Message.info("手机号码格式错误!");
            } else {
                this.$refs.verfy.Show();
            }
        },

        //验证码通过
        verifySuccess() {
            this.sendCodeBtnDisabled = true;
            this.sendCodeTimeCount = 60;
            postSendSms(this.formValidate.contactPhone).then((res) => {
                if (res.code == 200) {
                    this.sendCodeTimer = setInterval(() => {
                        this.sendCodeTimeCount = this.sendCodeTimeCount - 1;
                        if (this.sendCodeTimeCount < 0) {
                            this.sendCodeBtnDisabled = false;
                            clearInterval(this.sendCodeTimer);
                        }
                    }, 1000);
                } else {
                    this.$Message.error("验证码获取错误");
                }
            });
        },

        //获取省信息
        async getQueryProvince() {
            let res = await getQueryChina(0);
            if (res.code == 200) {
                this.provinceList = res.data;
            }
        },

        //获取市信息
        async getQueryCity(val) {
            let res = await getQueryChina(val);
            if (res.code == 200) {
                this.cityList = res.data;
            }
        },

        //出发input标签事件
        updateImg() {
            this.$refs.updateImgInput.click();
        },

        //选择后的事件
        async updateChange(event) {
            let Max_Size = 1024;//100KB
            if (
                event.target.files[0].type === "image/jpeg" ||
                event.target.files[0].type === "image/png" ||
                event.target.files[0].type === "image/jpg"
            ) {
                if (event.target.files[0].size * 0.0009766 > Max_Size) {
                    this.$Message.error("企业logo图片大小不能大于1MB！");
                    return;
                } else {
                    let res = await postUploadPhoto(event.target.files[0]);
                    if (res.code == 200) {
                        this.formValidate.logo = res.data.url;
                        this.$refs.formValidate.validateField("logo");
                    }
                }
            } else {
                this.$Message.error("企业logo只能上传图片类型，请重新上传！");
            }
        },

        // loginModalShow() {
        //     this.modalStatus = false;
        //     this.$refs["registerOneForm"].resetFields();
        //     this.$emit("loginModalShow");
        // },

        handleClose() {
            this.modalStatus = false;
            this.$refs["formValidate"].resetFields();
        },

        handleReg() {
            this.loading = true;

            this.$refs["formValidate"].validate((valid) => {
                if (valid) {
                    this.loading = false;
                    let provinceItem = this.provinceList.find(
                        (x) => x.id == this.formValidate.provinceId
                    );
                    this.formValidate.provinceName = provinceItem.name;
                    let cityItem = this.cityList.find(
                        (x) => x.id == this.formValidate.cityId
                    );
                    this.formValidate.cityName = cityItem.name;

                    this.$emit("handleComRegister", this.formValidate);

                    // postEntSysUser(this.formValidate).then((res) => {
                    //     if (res.code == 200) {
                    //         if (res.data) {
                    //             this.$Message.success("企业用户注册成功");

                    //             this.modalStatus = false;
                    //             setTimeout(() => {
                    //                 this.$refs["formValidate"].resetFields();
                    //                 this.loading = false;
                    //             }, 1000);
                    //         }
                    //     } else {
                    //         this.$Message.warning(res.message);
                    //     }
                    // });
                }
            });
        },
    },
};
</script>
<style scoped>
.login-header {
    height: 98px;
    line-height: 98px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.register-txt {
    color: #2d8cf0;
    cursor: pointer;
}

.register-txt:hover {
    color: #2d8cf0;
}
</style>


// WEBPACK FOOTER //
// src/components/ModalComReg.vue